import { kritisOn, extOk, companyMap } from './policy';

// KRITIS network guard: every request to a third-party host is checked against the admin's allow list
const BACKEND = new URL(process.env.REACT_APP_BACKEND_URL).origin;
const TILE = /(^|\.)(mt\d\.google\.com|arcgisonline\.com|tile\.openstreetmap\.org|opentopomap\.org)$/;
export function groupOf(raw) {
  let u;
  try { u = new URL(raw, window.location.href); } catch { return null; }
  if (!/^https?:$/.test(u.protocol) || u.origin === window.location.origin || u.origin === BACKEND) return null;
  const own = companyMap()?.url;
  if (own) { try { if (new URL(own).host === u.host) return null; } catch { /* invalid */ } }
  const h = u.hostname;
  if (TILE.test(h)) return 'tiles';
  if (h === 's3.amazonaws.com' && u.pathname.includes('elevation-tiles')) return 'elev';
  if (h.endsWith('open-meteo.com')) return u.pathname.includes('elevation') ? 'elev' : h.startsWith('geocoding') ? 'search' : 'weather';
  if (/overpass|maps\.mail\.ru/.test(h)) return 'osm';
  if (h === 'routing.openstreetmap.de' || (/google\./.test(h) && /\/maps|dir/.test(u.pathname + u.search)) || h === 'maps.google.com') return 'route';
  if (/nominatim|photon/.test(h)) return 'search';
  return 'other';
}
// true = request may leave the device
export const netOk = (url) => { if (!kritisOn()) return true; const g = groupOf(url); return !g || extOk(g); };
const block = () => window.dispatchEvent(new Event('giss-kritis-block'));

if (!window.__gissNetGuard) {
  window.__gissNetGuard = true;
  const f = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const url = typeof input === 'string' ? input : input?.url || String(input);
    if (!netOk(url)) { block(); return Promise.reject(new TypeError('kritis')); }
    return f(input, init);
  };
  const xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function open(m, url, ...r) { if (!netOk(String(url))) { block(); throw new TypeError('kritis'); } return xo.call(this, m, url, ...r); };
  // links (<a href> to Google Maps etc.)
  const onLink = (e) => { const a = e.target?.closest?.('a[href]'); if (a && !netOk(a.href)) { e.preventDefault(); e.stopPropagation(); block(); } };
  document.addEventListener('click', onLink, true);
  document.addEventListener('auxclick', onLink, true);
  const wo = window.open.bind(window);
  // empty placeholder tab (later pointed at Google Maps) only when routing is allowed
  window.open = (url, ...r) => { if ((!url || url === 'about:blank') ? kritisOn() && !extOk('route') : !netOk(String(url))) { if (url) block(); return null; } return wo(url, ...r); };
  // images (map tiles, 3D textures, DEM): silently a transparent pixel
  const d = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
  const EMPTY = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  Object.defineProperty(HTMLImageElement.prototype, 'src', { ...d, set(v) { d.set.call(this, netOk(String(v)) ? v : EMPTY); } });
}
